<div class="modal solid open"  id="HybridCloudRegistrationAlert">
    <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
    <div class="title">Your Network Controller Needs to be Registered</div>
    <div class="network-issue-icon icon-Network-Failure"></div>

    <div class="sized">
      <lib-network-controller-registration [networkController]="data.networkController"></lib-network-controller-registration>
    </div>
        
    <div class="buttons">
        <button (click)="close()" class="save" id="CloseNetworkInfoButton">OK</button>
    </div>
</div>